import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.UpgradeAdvancedPlanNotification', {
    trialOfAllFeatures: 'Trial of all features for “{companyName}” will expire in {expiryDays} days',
    trialOfAllFeaturesMultiple: 'Trial of all features for {count} organisations will expire in {expiryDays} days',
    linkText: 'Contact sales',
    seePricing: 'See pricing',
    hide: 'Hide',
});
